'use client';

import React from 'react';
import Image from 'next/image';
import { getOrgMetaClient } from '@/config/client';
import { getRuntimeOrg, imageSrc } from '@/utils/runtimeOrg';

const ErrorLogo: React.FC = () => {
  const meta = getOrgMetaClient(getRuntimeOrg());

  if (!meta.logo) return null;

  return (
    <Image
      src={imageSrc(meta.logo)}
      alt={meta.name}
      fill
      priority
      className="object-contain object-left"
    />
  );
};

export default ErrorLogo;
